module.exports = __webpack_public_path__ + "img/26-jeep-compass.df4d3bc2.jpg";